import { LessonVideo } from '../../types/Courses';

export const sortPlaylist = (playlist: LessonVideo[]): LessonVideo[] => {

  const highestPosition = playlist
    .filter((el) => el.playlist_pos !== null)
    .reduce((max, el) => Math.max(max, el?.playlist_pos ?? 0), 0);
  let nextPosition = highestPosition;
  const filledNullPositions = playlist.map((video) => {
    if (video.playlist_pos === null) {
      nextPosition += 1;
      return { ...video, playlist_pos: nextPosition };
    }
    return video;
  });
  const sorted = [...filledNullPositions].sort(
    (a, b) => (a?.playlist_pos ?? 0) - (b?.playlist_pos ?? 0),
  );
  return sorted;
};
